<template>
    <div>
      <loadingcomp
        v-bind:mesaj="loadingmesaj"
        v-model="loadingvmodel"
      ></loadingcomp>
      <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
  
      <v-dialog
        persistent
        max-width="700px"
        v-model="dialog"
        @keydown.esc="cancel"
      >
        <v-card>
          <v-card-title style="background-color: #01579b">
            <span class="headline white--text">Fiş Kopyala</span>
          </v-card-title>
          <v-card-text class="pa-4">
            <v-layout row wrap>
                <v-flex xs12 sm12 md12>
                  <v-select
                        :items="this.credentials.MuhasebeSirketler"
                       :item-text="item => item.CompanyShortName +' - '+ '(Firma No: ' +  item.CompanyID + ')'"
                        item-value="CompanyID"
                        label="Eski Muhasebe Firması"
                        v-model="fisKopyalaRequest.OldCompanyID"
                        :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                      ></v-select> 
                </v-flex>
               
              </v-layout>
              <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                  <v-select
                        :items="this.credentials.MuhasebeSirketler"
                        :item-text="item => item.CompanyShortName +' - '+ '(Firma No: ' +  item.CompanyID + ')'"
                        item-value="CompanyID"
                        label="Yeni Muhasebe Firması"
                        v-model="fisKopyalaRequest.NewCompanyID"
                        :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                      ></v-select> 
                </v-flex>
              </v-layout>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-form ref="fisNumarasiDegistir">
                  <v-flex xs12 sm12 md12>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md6>
                        <v-text-field
                  label="Eski Fiş Numarası"
                  v-model="fisKopyalaRequest.OldFicheNumber"
                ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md6>
                        <tarihcomp
                          etiket="Eski Fiş Tarihi"
                          v-bind:detaygizle="true"
                          v-bind:defaultvalue="'no'"
                          v-model="fisKopyalaRequest.OldFicheDate"
                        >
                        </tarihcomp>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md6>
                        <v-text-field
                  label="Yeni Fiş Numarası"
                  v-model="fisKopyalaRequest.NewFicheNumber"
                ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md6>
                        <tarihcomp
                          etiket="Yeni Fiş Tarihi"
                          v-bind:detaygizle="true"
                          v-bind:defaultvalue="'no'"
                          v-model="fisKopyalaRequest.NewFicheDate"
                        >
                        </tarihcomp>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-form>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12 sm6 md12>
                                                <v-checkbox v-model="fisKopyalaRequest.Reverse" label="Ters Çevir" false-value="0"  true-value="1" hide-details>
                                                
                                                </v-checkbox>
                                            </v-flex>
               
              </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" text @click.native="agree">
              {{ $t("Copy") }}
            </v-btn>
            <v-btn color="grey" text @click.native="cancel">{{
              $t("cancel_button")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  
      <v-dialog persistent max-width="700px" v-model="controlDialog">
        <v-card>
          <v-card-title class="error">
            <span class="headline white--text">Uyarı</span>
          </v-card-title>
          <v-card-text class="pa-4">
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <blockquote>
                  Fiş Kopyalama İşlemi Yapılacaktır ?
                </blockquote>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" text @click.native="makeChange()">
              {{ $t("Copy") }}
            </v-btn>
            <v-btn color="grey" text @click.native="controlDialog = false">{{
              $t("cancel_button")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script>
  import tarihcomp from "@/components/app/customcomp/tarihim";
  import auth from "../../../../../api/auth";
  import loadingcomp from "@/components/app/customcomp/loadingcomp";
  import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
  
  export default {
    data() {
      return {
        credentials: JSON.parse(window.localStorage.getItem("credentials")),
        controlDialog: false,
        dialog: false,
        loadingvmodel: false,
        text1: null,
        snackbar: false,
        loadingmesaj: "Fiş Kopyala",
        tumSirketler: false,
        fisKopyalaRequest: {
          CompanyID: 0,
          OldFicheNumber: null,
          OldFicheDate: null,
          NewFicheNumber: null,
          NewFicheDate: null,
          OldCompanyID :null,
          NewCompanyID :null,
          Reverse :0,
          UserID:0
        },
      };
    },
    components: {
      tarihcomp,
      loadingcomp,
      snackbarcomp,
    },
    methods: {
      makeChange() {
        this.loadingvmodel = true
         this.fisKopyalaRequest.CompanyID=this.credentials.MuhasebeSirketNo;
         this.fisKopyalaRequest.UserID=this.credentials.UserID;
          var Params = this.fisKopyalaRequest
          this.$http.post(auth.API_URL + 'api/AccountingParameters/FicheCopy', Params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
  
            console.log(response);
  
            this.loadingvmodel = false
            this.text1 =  response.body.ResponseMessage;
            this.snackbar =true;
  
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Hata-' + response.body.ResponseMessage;
              this.snackbar =true;
              this.loadingvmodel = false
            } else {
              this.text1 = 'Service- FicheNumberOrder';
              this.snackbar =true;
              this.loadingvmodel = false
            }
          })
        
         
          this.controlDialog = false;
          this.dialog=false;
      },
      open() {
        this.dialog = true;
      },
      agree() {
        this.controlDialog = true;
      },
      cancel() {
        this.dialog = false;
      },
    },
  };
  </script>
  
  <style>
  </style>
  